export default "__VITE_ASSET__YfdnDgRj__"